import * as Sentry from "@sentry/react";

let environment = import.meta.env.VITE_NODE_ENV;
let authorityEnvironment = 'authority-' + environment;

Sentry.init({
    dsn: "https://0d8a9d9adc3eef467def3b3a6cfe1437@o4507191276339200.ingest.de.sentry.io/4507191278436432",
    environment: authorityEnvironment,
    sendDefaultPii: true,
    integrations: [],
});
